var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-flip-image-control text-center"
  }, [_c('button', {
    class: ['icon icon-flip', {
      activate: _vm.flippedVertical
    }],
    on: {
      "click": _vm.flipVerticalClick
    }
  }), _c('button', {
    class: ['icon icon-flip icon-flipped', {
      activate: _vm.flippedHorizontal
    }],
    on: {
      "click": _vm.flipHorizontalClick
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }